module.exports = __webpack_public_path__ + "img/bb.6089a383.svg";